import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/speaker_mute.png'
import _imports_1 from '@assets/speaker_on.png'
import _imports_2 from '@assets/emoji_robot.png'
import _imports_3 from '@assets/emoji_fox.png'


const _withScopeId = n => (_pushScopeId("data-v-2469a8c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = { class: "tabbar" }
const _hoisted_5 = { class: "other_profile" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "other_picture",
    src: _imports_2
  })
], -1))
const _hoisted_7 = { class: "other_profile_info" }
const _hoisted_8 = { class: "wrap_chat_screen" }
const _hoisted_9 = { class: "room_info" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other_icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my_icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "wrap_input_screen" }
const _hoisted_19 = { class: "wrap_input" }
const _hoisted_20 = ["onKeypress"]

import { useRoute } from 'vue-router';
import {
  ref,
  onMounted,
  computed,
  watch,
} from 'vue';
import { AutoTyperVue } from 'auto-typer-vue3';
import TypingText from '@components/TypingText.vue';
import { useSpeechRecognitionStore } from '../stores/storeSpeechRecognition';
import { useAvatarStore } from '../stores/storeAvatar';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import { useAudioStore } from '../stores/storeAudio';
import { requestPostChatWithAvatar } from '@apis/voicechat';
import { postStreams } from '@apis/streams';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatAvatar',
  setup(__props) {

const route = useRoute();
const avatarId = Number(route.query.id);
const avatarStore = useAvatarStore();
const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};

const chatScreenRef = ref<HTMLElement | null>(null);
const scrollToBottom = () => {
  if (chatScreenRef.value) {
    chatScreenRef.value.scrollTop = chatScreenRef.value.scrollHeight;
  }
};
const isMute = ref(false);

const turnMute = () => {
  isMute.value = !isMute.value;
};
const messages = computed(() => avatarStore.avatarMessageList[avatarStore.currentAvatarId]);
const currentAvatarId = computed(() => avatarStore.currentAvatarId);
const currentAvatarInfo = computed(() => avatarStore.currentAvatarInfo);
const currentUserId = computed(() => avatarStore.currentUserId);
const avatarLastChat = computed(() => avatarStore.avatarLastChat);
const newMessage = ref<string>('');
const isSpeaking = ref(true);
const typingLastChat = ref('');
// const getMessageContent = computed((msg: iGPTMessage) => {
//   if (msg.role == 'assistant' && msg.content == avatarStore.avatarLastChat ) {
//     const typedText = ref('');
//     let index = 0;
//     if (index < msg.content.length) {
//        typedText.value = msg.content.substring(0, index);
//        index += 1;
//        setTimeout(ViewText, 100);
//      }
//   } else {
//     return msg.content;
//   }
// });

const sendMessage = async () => {
  console.log('sending messages', newMessage.value);
  console.log('currentAvatarInfo', currentAvatarInfo.value);
  const chat = newMessage.value.trim();
  console.log('chat', chat);
  newMessage.value = '';

  if (chat !== '') {
    avatarStore.addAvatarMessage(currentAvatarId.value, {
      content: chat,
      role: 'user',
    });

    try {
      const res = await requestPostChatWithAvatar(
        currentUserId.value,
        currentAvatarId.value,
        {
          user_message: chat,
          persona: avatarStore.getPersonaFromCurrentAvatarInfo(),
        },
      );
      console.log('res [requestPostChatWithAvatar]', res);
      avatarStore.addAvatarMessage(currentAvatarId.value, {
        content: res.data.answer,
        role: 'assistant',
      });
      setTimeout(() => {
        scrollToBottom();
      }, 600);

      // Use res here
    } catch (error: any) {
      console.error('Request failed:', error);
      // Handle error
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
    }
  }
};

const handleEnterKey = () => {
  sendMessage();
  newMessage.value = '';
};

const handleShiftEnterKey = (event: any) => {
  if (event.shiftKey) {
    // 쉬프트 키를 누르면서 엔터 키를 눌렀을 때
    newMessage.value += '\n'; // 또는 다른 줄바꿈 처리 방법을 사용할 수 있습니다.
  } else {
    // 쉬프트 키 없이 엔터 키만 눌렀을 때
    handleEnterKey();
  }
};

// STT
const speechRecognitionStore = useSpeechRecognitionStore();
const handleSpeechResult = (spokenText: string | null) => {
  if (spokenText) {
    newMessage.value = spokenText;
    sendMessage();
  }
};
const startSpeechListening = () => {
  speechRecognitionStore.startSpeechRecognition(handleSpeechResult);
};
const stopSpeechListening = () => {
  speechRecognitionStore.stopSpeechRecognition();
};
const isListening = computed(() => speechRecognitionStore.isListening);

// TTS
const streamAvatar = async (quest: string, id: number) => {
  const params = {
    quest,
    avatar_id: id,
  };
  try {
    const audioStore = useAudioStore();
    console.log('call streamAvatar', '🩷🩷');
    postStreams('avatar', params.quest, params.avatar_id.toString());
  } catch (error) {
    console.log(error);
  }
};

const sleep = async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

watch(
  () => avatarStore.avatarLastChat,
  (newValue, oldValue) => {
    console.log('watch :', newValue, oldValue);
    // 속성 값이 변경될 때 실행되는 로직
    if (isSpeaking.value && newValue && !isMute.value) {
      console.log('[content] :', newValue, '[isSpeaking]:', isSpeaking.value);
      streamAvatar(newValue, currentAvatarId.value);
    }
    // typingLastChat.value = '';
    // const lines = newValue.split('\n');
    // for (let lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
    //   // const line = lines[index];
    //   // if (isSpeaking.value && line) {
    //   //   console.log('[content] :', line, '[isSpeaking]:', isSpeaking.value);
    //   //   streamAvatar(line, currentAvatarId.value);
    //   // }
    //   const words = lines[lineIndex].split(' ');
    //   for (let wordIndex = 0; wordIndex < words.length; wordIndex += 1) {
    //     (async () => {
    //       typingLastChat.value = `${typingLastChat.value}${words[wordIndex]} `;
    //       await sleep(50);
    //     })();
    //   }
    //   typingLastChat.value += '\n';
    // }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "mute",
      onClick: turnMute
    }, [
      (isMute.value)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (_openBlock(), _createElementBlock("img", _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_font_awesome_icon, {
        class: "chevron",
        icon: "fa-solid fa-bars",
        onClick: showMobileMenu
      }),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, _toDisplayString(currentAvatarInfo.value.name), 1)
        ])
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "chatScreenRef",
      ref: chatScreenRef,
      class: "scroll"
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, _toDisplayString(currentAvatarInfo.value.name) + "와 대화를 시작해보세요", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass({
            'bubble': true,
            'other_bubble': message.role !== 'user',
            'my_bubble': message.role === 'user'
          })
          }, [
            (message.role !== 'user')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
              : _createCommentVNode("", true),
            (message.role === 'user')
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true),
            (message.role === 'assistant' && message.content === avatarLastChat.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                  _createVNode(_unref(AutoTyperVue), {
                    text: message.content,
                    repeat: false
                  }, null, 8, ["text"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(message.content), 1))
          ], 2))
        }), 128))
      ])
    ], 512),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newMessage).value = $event)),
          class: "input",
          placeholder: "Message",
          onKeypress: _withKeys(_withModifiers(handleShiftEnterKey, ["exact","prevent"]), ["enter"])
        }, null, 40, _hoisted_20), [
          [_vModelText, newMessage.value]
        ]),
        (!isListening.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button_rec",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (startSpeechListening()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-microphone" })
            ]))
          : _createCommentVNode("", true),
        (isListening.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button_rec",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (stopSpeechListening()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-square" })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})